import { NoteMeta } from '../models/types';

export function hasMeaningfulNoteContent(note: NoteMeta | null | undefined): boolean {
  return hasMeaningfulNoteText(note?.text ?? '');
}

export function hasMeaningfulNoteText(value: string | null | undefined): boolean {
  if (!value) {
    return false;
  }

  const normalized = value
    .replace(/<br\s*\/?>/gi, ' ')
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/\u00a0/g, ' ');

  return normalized.trim().length > 0;
}
